import ComponentPage from './ComponentPage';
import GettingStarted from './GettingStarted';
import Modifiers from './Modifiers';
import Presets from './Presets';
import SideMenu from './SideMenu';
import ThemeManager from './ThemeManager';


module.exports = {
  ComponentPage,
  GettingStarted,
  Modifiers,
  Presets,
  SideMenu,
  ThemeManager,
};



// WEBPACK FOOTER //
// ./components/index.js